import {IBaseLookup} from "./Ibase.lookup";

export namespace ScanDocTypeDetail {

    export const lookupName: string = "ScanDocTypeDetail";

    export interface ScanBarcode {
        scanBarcodeKey: number;
        scanDocTypeKey: number;
        name: string;
        barcodeType: number;
        orientation: number;
        active: string;
        lastUpdated: Date;
    }

    export interface ScanDocTypes {
        scanDocTypeKey: number;
        scanDocTypeName: string;
        docHeight: number;
        docWidth: number;
        dpi: number;
        cropOriginX: number;
        cropOriginY: number;
        cropHeight: number;
        cropWidth: number;
        palette: number;
        colorDepth: number;
        autoDeskew: string;
        removeNoise: string;
        active: string;
        lastUpdated: Date;
        orientation: number;
        authorization: string;
        defaultZoom: string;
        docLevel: number;
        priority: number;
    }

    export interface ScanDocLevel {
    	scanDocLevelKey: number;
    	scanDocLevel: string;
    	code: string;
    	description: string;
		active: string;
		lastUpdated: Date;
	}

    export interface ScanDocTypeDetailDS extends IBaseLookup {
        scanBarcode: ScanBarcode[];
        scanDocTypes: ScanDocTypes[];
        scanDocLevel: ScanDocLevel[];
    }
}
